import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'
import type { GoogleAdsCampaign } from 'honeygrid-types/GoogleAds'
import { toast } from 'sonner'

export const googleAdsCampaignsQueryKey = 'googleAdsCampaigns'

interface GoogleAdsCampaignsParams {
	workspaceId?: string
	connectionId: string
}

export const useGoogleAdsCampaigns = ({
	workspaceId = '',
	connectionId,
}: GoogleAdsCampaignsParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<{ campaigns: GoogleAdsCampaign[] }>({
		queryKey: [googleAdsCampaignsQueryKey, workspaceId, connectionId],
		queryFn: async () => {
			if (!workspaceId) {
				toast.error('Workspace ID is required')
				throw new Error('Workspace ID is required')
			}
			return authFetch(`workspaces/${workspaceId}/connections/${connectionId}/campaigns`)
		},
		enabled: !!connectionId && !!workspaceId,
	})
}
